class HBRelatedProducts extends HTMLElement {
  connectedCallback() {
    var url = this.dataset.url;
    if (!url) return;

    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(
        function (text) {
          var html = document.createElement('div');
          html.innerHTML = text;
          var grid = html.querySelector('.hb-related-products__grid');

          if (grid && grid.children.length > 0) {
            this.innerHTML = html.querySelector('hb-related-products').innerHTML;
          } else {
            this.remove();
          }
        }.bind(this)
      )
      .catch(function () {});
  }
}

customElements.define('hb-related-products', HBRelatedProducts);
